/*
 * @Description:
 * @Autor: lwq
 * @Date: 2020-06-12 18:37:02
 */
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './vuetify'
import i18n from '@/lang'
import plugin from '@/components/index'
import myMixin from '@/mixin/index'
import directives from './directives'
import Vuelidate from 'vuelidate'
import VueAzureUploader from 'vue-azure-blob-upload'
import moment from 'moment'
import '@/assets/css/common.css'
import '@/assets/css/myDefault.css'
import '@/assets/css/default.css'
import '@/assets/icons/index'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
Vue.config.productionTip = false
Vue.config.performance = process.env.NODE_ENV !== 'production'
Vue.use(VueAzureUploader)

Vue.use(plugin)

Vue.use(myMixin)
Vue.use(Vuelidate)
Vue.use(directives)
    // 页面刷新重新加载国际化
    // i18n.mergeLocaleMessage(store.state.lang, store.state.languageList)
const langs = Object.keys(store.state.languageList)
const values = Object.values(store.state.languageList)
langs.forEach((item, index) => {
    if (item != 'code' || item != 'status' || item != 'msg')
        i18n.mergeLocaleMessage(item, values[index])
})
Vue.filter('changeDate', function(value, value2 = 'YYYY/MM/DD') {
    if (!value) return ''
    value = moment(value).format(value2)
    return value
})
new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: (h) => h(App),
}).$mount('#app')